import React     from 'react';
import { Theme } from '../../../theme';
import styles from './Text.css';
import classNames from 'classnames';

type TextProps = {
    align?: string;
    margin?: string;
    bold?: boolean;
    size?: string;
    color?: string;
    theme?: Theme;
    as?: string;
    children?: any;
    style?: any;
    className?: string;
    content?: string;
    isDangerously?: boolean;
    width?:string;
    lang?:string;
    ariaExpanded? :string;
    ariaLabel? :string;
    role? :string;
    ariaLive? :string;
};
export const Text = React.memo((props: TextProps) => {
    const Component: any = props.as || 'span';
    const dangerously = props.isDangerously ?  {dangerouslySetInnerHTML: {__html: props.content }} : { };
    const lang = props.lang ?  {lang: props.lang } : { };
    const ariaExpanded = props.ariaExpanded ? {"aria-expanded": props.ariaExpanded } : { };
    const ariaLabel = props.ariaLabel ? {"aria-label": props.ariaLabel } : { };
    const role = props.role ? {"role": props.role } : { };
    const ariaLive = props.role ? {"aria-live": props.ariaLive } : { };
    return (
        <Component
            {...dangerously}
            {...lang}
            {...ariaExpanded}
            {...ariaLabel}
            {...role}
            {...ariaLive}
            
            style = {{
                margin: props.margin,
                width: props.width,
                ...props.style
            }}
            className = {
                classNames(styles.Base, {
                    [styles.Bold]: props.bold,
                    [styles[`color-${props.color}`]]: !!props.color,
                    [styles[`size-${props.size}`]]: !!props.size,
                    [styles[`align-${props.align}`]]: !!props.align,
                }, props.className)
            }
        >
            {props.isDangerously ? null : props.children}
        </Component>
    );
});

Text.displayName = 'Text';
